export default "__VITE_ASSET__CDUql1fo__"